import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  makeStyles,
  Paper,
  Grid,
  Typography,
  IconButton,
  Tooltip,
  Button
} from '@material-ui/core';
import { updateProcess } from 'store/actions/sales';
import {
  ArrowDownward as ArrowDownwardIcon,
  ArrowUpward as ArrowUpwardIcon,
  CloudUpload as CloudUploadIcon,
  Description as DescriptionIcon
} from '@material-ui/icons';
import { sameRelation } from 'constants/sales';
import { uploadFile, downloadFile } from 'api';

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2, 3), marginBottom: 0 },
  column: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
  button: { width: 35, height: 35 },
  fileInputContainer: { marginTop: theme.spacing(1) },
  fileButton: { marginTop: theme.spacing(1), textTransform: 'none' },
  fileInfo: { marginTop: theme.spacing(1), display: 'flex', alignItems: 'center', gap: theme.spacing(1) },
}));

function PhaseRow({ process, phase, totalPhases, unique, ...props }) {
  const classes = useStyles(props);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);

    const formData = new FormData();
    formData.append('process_id', process.id);
    formData.append('file', file);

    try {
      const data = await uploadFile('process/upload', formData);
    } catch (err) {
      console.error("[DEBUG] Erro no upload:", err);
    }
  };

  const handleDownload = () => {
    if (!process.upload_file_name) return;
    downloadFile(`process/download/${process.id}`, process.upload_file_name)
      .then(() => console.log("Download iniciado com sucesso"))
      .catch((err) => console.error("Erro no download:", err));
  };

  const handleMovePhase = (goingUp) => {
    const newPhase = phase - 1;
    props.updateProcess({
      clientId: props.scope.client_id,
      data: { phase: goingUp ? newPhase + 1 : newPhase - 1 },
      scopeId: props.scope.id,
      processId: process.id
    });
  };

  return (
    <Paper elevation={3} className={classes.root}>
      <Grid container spacing={2}>
        <Grid item className={classes.column} xs={4}>
          <Typography color="textSecondary"><strong>Nome</strong></Typography>
          <Typography>{process.applicant.name}</Typography>
          {process.host_relations !== sameRelation && (
            <Typography color="textSecondary">{`${process.host_relations} de ${process.hosts[0].name}`}</Typography>
          )}
        </Grid>
        <Grid item className={classes.column} xs={3}>
          <Typography color="textSecondary"><strong>Data de nascimento</strong></Typography>
          <Typography color="textPrimary">{process.applicant.birthdate}</Typography>
        </Grid>
        <Grid item className={classes.column} xs={3}>
          <Typography color="textSecondary"><strong>Processo</strong></Typography>
          <Typography>{process.products[0].title}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography color="textSecondary"><strong>Anexo do processo</strong></Typography>
          <div className={classes.fileInputContainer}>
            <input
              type="file"
              id={`file-input-${process.id}`}
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
            <label htmlFor={`file-input-${process.id}`}>
              <Button
                variant="outlined"
                color="primary"
                component="span"
                className={classes.fileButton}
                startIcon={<CloudUploadIcon />}
              >
                Selecionar arquivo
              </Button>
            </label>
          </div>
          {selectedFile ? (
            <div className={classes.fileInfo}>
              <DescriptionIcon fontSize="small" color="action" />
              <Typography variant="body2">{selectedFile.name}</Typography>
            </div>
          ) : process.upload_file_name ? (
            <div className={classes.fileInfo}>
              <DescriptionIcon fontSize="small" color="action" />
              <Typography variant="body2">{process.upload_file_name}</Typography>
              <Tooltip title={`Baixar arquivo: ${process.upload_file_name}`}>
                <IconButton
                  color="primary"
                  size="small"
                  onClick={handleDownload}
                >
                  <ArrowDownwardIcon />
                </IconButton>
              </Tooltip>

            </div>
          ) : null}
        </Grid>
        <Grid item className={classes.column} xs={2}>
          {((phase > 1 && !unique) || (unique && phase > 1 && phase === totalPhases)) && (
            <Typography align="right">
              <Tooltip title={`Passar para a fase ${phase - 1}`}>
                <IconButton onClick={() => handleMovePhase(false)} aria-label="fase acima" className={classes.button} size="small">
                  <ArrowUpwardIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
            </Typography>
          )}
          {totalPhases >= phase && !unique && (
            <Typography align="right">
              <Tooltip title={`Passar para a fase ${phase + 1}`}>
                <IconButton onClick={() => handleMovePhase(true)} aria-label="fase abaixo" className={classes.button} size="small">
                  <ArrowDownwardIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
            </Typography>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
}

const mapStateToProps = (state) => ({
  scope: state.sales.scope,
});

const actions = { updateProcess };

export default connect(mapStateToProps, actions)(PhaseRow);
